import { useLanguage } from '../../../contexts/useLanguage';

export default function Download() {
  const { language } = useLanguage();

  const content = {
    zh: {
      badge: '现已登陆App Store',
      title: '开启你的创作之旅',
      description: '立即下载AI漫画生成器，用AI的力量释放你的创造力，创作属于你的精彩漫画故事',
      downloadOn: '下载',
      appStore: 'App Store',
      stat1: '4.8',
      stat1Label: '用户评分',
      stat2: '10+',
      stat2Label: '国家地区',
      stat3: '1万+',
      stat3Label: '活跃用户',
      stat4: '10万+',
      stat4Label: '创作作品',
      regionsLabel: '支持地区：',
      regions: '美国、英国、加拿大、西班牙、日本、香港等'
    },
    en: {
      badge: 'Now Available on App Store',
      title: 'Start Your Creative Journey',
      description: 'Download AiComic now, unleash your creativity with AI power, create your own wonderful comic stories',
      downloadOn: 'Download on the',
      appStore: 'App Store',
      stat1: '4.8',
      stat1Label: 'User Rating',
      stat2: '10+',
      stat2Label: 'Countries & Regions',
      stat3: '10K+',
      stat3Label: 'Active Users',
      stat4: '100K+',
      stat4Label: 'Creative Works',
      regionsLabel: 'Supported Regions:',
      regions: 'USA, UK, Canada, Spain, Japan, Hong Kong, etc.'
    }
  };

  const t = content[language];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center space-x-2 bg-gray-900 px-4 py-2 rounded-full mb-6">
            <i className="ri-download-line text-white text-sm"></i>
            <span className="text-white text-sm font-medium">{t.badge}</span>
          </div>
        </div>

        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
          {t.title}
        </h2>

        <p className="text-xl text-gray-700 font-light mb-12 max-w-2xl mx-auto">
          {t.description}
        </p>

        <div className="flex justify-center mb-16">
          <a
            href="https://apps.apple.com/us/app/alcomic/id6744306216?platform=iphone"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 px-8 py-4 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-apple-fill text-2xl"></i>
            <div className="text-left">
              <div className="text-xs">{t.downloadOn}</div>
              <div className="text-base font-bold">{t.appStore}</div>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mb-12">
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t.stat1}</div>
            <div className="text-sm text-gray-600">{t.stat1Label}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t.stat2}</div>
            <div className="text-sm text-gray-600">{t.stat2Label}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t.stat3}</div>
            <div className="text-sm text-gray-600">{t.stat3Label}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t.stat4}</div>
            <div className="text-sm text-gray-600">{t.stat4Label}</div>
          </div>
        </div>

        <div className="text-sm text-gray-600">
          <span className="font-medium text-gray-700">{t.regionsLabel}</span>
          {' '}{t.regions}
        </div>
      </div>
    </section>
  );
}
